import { translate } from "app/filters/i18nFilter";
import {
    StyledCountryCell,
    StyledDefaultCell,
} from "app/pages/sales-intelligence/sub-modules/signals/components/tooltips/shared/styles";
import type TooltipTableColumn from "../../../../models/view/signals-tooltip/TooltipTableColumn";
import createSignalsTooltipTableColumn from "../../base/toolipBaseColumnFactory";
import { TOOLTIP_COLUMN_COUNTRY_NAME, TOOLTIP_COLUMN_METRIC_NAME } from "./const";

type FactoryDeps = {
    metric: string;
};

export default function createTooltipColumnsResolver({ metric }: FactoryDeps) {
    const COLUMN_DISPLAY_NAME_KEY = "si.signals.table-columns.tooltip.table.column";

    return {
        getTableColumns(): TooltipTableColumn[] {
            return [
                createSignalsTooltipTableColumn({
                    field: TOOLTIP_COLUMN_COUNTRY_NAME,
                    maxWidth: 210,
                    cellComponent: StyledCountryCell,
                }),
                createSignalsTooltipTableColumn({
                    field: TOOLTIP_COLUMN_METRIC_NAME,
                    format: "minVisitsAbbr",
                    displayName: translate(`${COLUMN_DISPLAY_NAME_KEY}.${metric}`),
                    cellComponent: StyledDefaultCell,
                }),
            ];
        },
    };
}
